import { Reveal } from "./shared";
import { useSite } from "../../context/SiteContext";

export default function Differentials() {
  const { content } = useSite();
  const items = content?.differentials || [];
  if (!items.length) return null;

  return (
    <section id="diferenciais" className="py-20 lg:py-28 bg-cream" data-testid="differentials-section">
      <h2 className="sr-only">Diferenciais de Padre Lucas Macieira como celebrante de casamentos</h2>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-gold/20 rounded-2xl overflow-hidden gold-frame">
          {items.map((d, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-cream">
              <div className="p-6 sm:p-8 h-full hover:bg-warmwhite transition-colors duration-500 group">
                <span className="font-serif text-3xl text-gold/70 group-hover:text-gold transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 text-sm font-semibold uppercase tracking-[0.15em] text-olive leading-snug" data-testid={`differential-title-${i}`}>
                  {d.title}
                </h3>
                <p className="mt-3 text-sm font-light text-cocoa leading-relaxed">{d.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
